import React from "react";
import { Row, Col, InputNumber, Switch, Divider } from "antd";

const ThresholdRow = ({
  label,
  minKey,
  maxKey,
  min,
  max,
  step,
  precision,
  fields,
  setField,
}) => (
  <Row gutter={16} className="mb-3 align-items-center">
    <Col span={8}>
      <label className="font-weight-bold">{label}</label>
    </Col>
    <Col span={8}>
      <InputNumber
        style={{ width: "100%" }}
        min={min}
        max={max}
        step={step}
        precision={precision}
        value={fields[minKey]}
        onChange={(v) => setField(minKey, v)}
      />
    </Col>
    <Col span={8}>
      <InputNumber
        style={{ width: "100%" }}
        min={min}
        max={max}
        step={step}
        precision={precision}
        value={fields[maxKey]}
        onChange={(v) => setField(maxKey, v)}
      />
    </Col>
  </Row>
);

const VitalThresholds = ({ fields, setField }) => (
  <div className="pt-2">
    <Row gutter={16} className="mb-2">
      <Col span={8} />
      <Col span={8}>
        <span className="text-muted small">最小值</span>
      </Col>
      <Col span={8}>
        <span className="text-muted small">最大值</span>
      </Col>
    </Row>

    <ThresholdRow
      label="體溫 (°C)"
      minKey="temp_min"
      maxKey="temp_max"
      min={30}
      max={45}
      step={0.1}
      precision={1}
      fields={fields}
      setField={setField}
    />
    <ThresholdRow
      label="心率 (BPM)"
      minKey="heart_rate_min"
      maxKey="heart_rate_max"
      min={30}
      max={250}
      step={1}
      precision={0}
      fields={fields}
      setField={setField}
    />
    <ThresholdRow
      label="收縮壓 (mmHg)"
      minKey="systolic_min"
      maxKey="systolic_max"
      min={60}
      max={250}
      step={1}
      precision={0}
      fields={fields}
      setField={setField}
    />
    <ThresholdRow
      label="舒張壓 (mmHg)"
      minKey="diastolic_min"
      maxKey="diastolic_max"
      min={40}
      max={150}
      step={1}
      precision={0}
      fields={fields}
      setField={setField}
    />

    <Divider />

    <Row gutter={16} className="align-items-center">
      <Col span={8}>
        <label className="font-weight-bold">血氧 (%)</label>
      </Col>
      <Col span={8}>
        <InputNumber
          style={{ width: "100%" }}
          min={50}
          max={100}
          value={fields.blood_oxygen_min}
          onChange={(v) => setField("blood_oxygen_min", v)}
        />
      </Col>
      <Col span={8}>
        <span className="text-muted small">僅設下限</span>
      </Col>
    </Row>

    <Divider />

    <Row gutter={16} className="mb-2">
      <Col span={10} />
      <Col span={4} className="text-center">
        <span className="text-muted small">偵測啟動</span>
      </Col>
      <Col span={10}>
        <span className="text-muted small">冷卻時間</span>
      </Col>
    </Row>
    <Row gutter={16} className="align-items-center">
      <Col span={10}>
        <label className="font-weight-bold">生命體徵異常警報</label>
      </Col>
      <Col span={4} className="text-center">
        <Switch
          checked={fields.health_abnormal_enabled}
          onChange={(v) => setField("health_abnormal_enabled", v)}
        />
      </Col>
      <Col span={10}>
        <InputNumber
          style={{ width: "100%" }}
          min={60}
          max={86400}
          step={60}
          value={fields.health_abnormal_cooldown_seconds}
          onChange={(v) => setField("health_abnormal_cooldown_seconds", v)}
          addonAfter="秒"
        />
      </Col>
    </Row>
  </div>
);

export default VitalThresholds;
